import StyledTitle from "./Title";

export default StyledTitle